<template>
  <div class="basicLayout">
    <el-container style="height: 100vh; background-color: #f8f8f8">
      <el-header class="page-title">
        <div
          class="trigger-wrap"
          :style="{width: isCollapse ? '64px' : '150px', minWidth: isCollapse ? '64px' : '150px'}"
        >
          <Icon
            type="ios-menu"
            v-if="isCollapse"
            class="trigger rotate90"
            @click="() => (isCollapse = !isCollapse)"
          />
          <Icon type="ios-menu" v-else class="trigger" @click="() => (isCollapse = !isCollapse)" />
        </div>
        <el-dropdown
          v-if="shiftList && shiftList.length > 1"
          class="head-item"
          @command="commandInstitution"
        >
          <div class="el-dropdown-link">
            <span style="font-size: 20px">{{ shift.institution_name || "请选择机构" }}</span>
            <i class="el-icon-arrow-down el-icon--right"></i>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="institution in shiftList"
              :key="institution.institution_id"
              :command="institution.institution_id"
            >{{ institution.institution_name }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <div
          v-else
          class="head-item"
          style="cursor: auto;font-size: 20px"
        >{{shift.institution_name}}</div>
        <div
          style="margin-left: 40px;flex: 1;display:flex;justify-content: center"
          v-show="isFilter"
        >
          <el-autocomplete
            v-if="!isFloat || (isFloat && !isToggle)"
            max="20"
            :maxlength="20"
            :debounce="0"
            class="inline-input"
            popper-class="my-autocomplete"
            ref="elautocomplete"
            v-model.trim="searchText"
            :fetch-suggestions="querySearch"
            placeholder="请输入"
            :trigger-on-focus="false"
            :hide-loading="loading"
            @select="patientDetail"
          >
            <i slot="suffix" class="el-input__icon el-icon-search" style="line-height: 35px"></i>
            <template slot-scope="{ item }" @click="patientDetail">
              <div v-if="item.index == '0'" class="p">找到{{ results.length }}条记录</div>
              <div class="name">
                <span style="color: #c0c4cc">{{ item.names }}</span>
              </div>
              <div class="name" v-if="item.names != '无匹配数据'">
                <span class="patient-avatar">
                  <img
                    v-if="item.gender === 0"
                    src="../images/woman.png"
                    style="width: 20px; vertical-align: middle"
                  />
                  <img v-else src="../images/man.png" style="width: 20px; vertical-align: middle" />
                </span>
                <span class="patient-name">{{ item.name }}</span>
                <span class="patient-age">{{ item.age }}岁</span>
                <span :class="item.type == '筛查' ? 'patient-type' : 'patient-typeMB'">{{ item.type }}</span>
              </div>
              <div class="name" v-if="item.names != '无匹配数据'">
                <div class="time">创建时间：{{item.create_time ? item.create_time.substring(0, 10) : ""}}</div>
                <div class="time">手机号码：{{ item.phone || "--" }}</div>
              </div>
            </template>
          </el-autocomplete>
          <!-- 新增患者入口 -->
          <el-dropdown
            v-if="!isFloat || (isFloat && isToggle)"
            split-button
            class="head-item patient-item"
            @command="handleClick"
          >
            <span @click="goToType" style="font-size: 13px">
              <i class="el-icon-plus"></i>
              {{ addType }}
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(item, index) in typeLists"
                :key="index"
                :command="item"
              >{{ item }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div ref="login" :class="['loginout', isFilter ? '' : 'flex']">
          <template v-if="shift.institution_name && curDeptList.length">
            <el-dropdown v-if="curDeptList.length > 1" class="head-item" @command="commandDept">
              <div class="el-dropdown-link">
                <span>{{ shift.dept_name || "请选择科室" }}</span>
                <i class="el-icon-arrow-down el-icon--right"></i>
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="dept in curDeptList"
                  :key="dept.dept_id"
                  :command="dept.dept_id"
                >{{ dept.dept_name }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <div v-else class="head-item" style="cursor: auto;">{{shift.dept_name}}</div>
          </template>
          <template v-if="shift.dept_name && curDiseaseList.length">
            <el-dropdown
              v-if="curDiseaseList.length > 1"
              class="head-item"
              @command="commandDisease"
            >
              <div class="el-dropdown-link">
                <span>{{ shift.disease_name || "请选择病种" }}</span>
                <i class="el-icon-arrow-down el-icon--right"></i>
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="disease in curDiseaseList"
                  :key="disease.disease_id"
                  :command="disease.disease_id"
                >{{ disease.disease_name }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <div v-else class="head-item" style="cursor: auto;">{{shift.disease_name}}</div>
          </template>
          <template v-if="shift.disease_name && curTeamList.length">
            <el-dropdown v-if="curTeamList.length > 1" class="head-item" @command="commandTeam">
              <div class="el-dropdown-link">
                <span>{{ shift.team_name || "请选择团队" }}</span>
                <i class="el-icon-arrow-down el-icon--right"></i>
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="team in curTeamList"
                  :key="team.team_id"
                  :command="team.team_id"
                >{{ team.team_name }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <div v-else class="head-item" style="cursor: auto;">{{shift.team_name}}</div>
          </template>
        </div>
        <!--未读消息-->
        <div style="margin-left:15px;" @click="openIm()" v-if="hasSlow">
          <div style="cursor:pointer;">
            <Badge :count="$store.state.badge">
              <Icon type="ios-chatbubbles-outline" color="#fff" :size="25" />
            </Badge>
          </div>
        </div>
        <el-dropdown
          class="loginout"
          style="margin-left: 40px; cursor: pointer"
          @command="handleCommand"
        >
          <div class="el-dropdown-link">
            <el-image
              v-if="user.user && user.user.avatar"
              style="margin: 0 auto;width: 36px;height:36px;border-radius: 50%"
              shape="circle"
              fit="cover"
              :src="user.user.avatar"
            ></el-image>
            <span
              v-else
              class="avatar-wrapper"
              :style="{background: avatarColor}"
            >{{user.user && user.user.name ? user.user.name.slice(0,1) : 'A'}}</span>
            <i class="el-icon-arrow-down el-icon--right"></i>
          </div>
          <el-dropdown-menu slot="dropdown">
            <!-- <el-dropdown-item command="goRouteUserSetting">个人设置</el-dropdown-item> -->
            <el-dropdown-item command="goRouteUserCenter">个人中心</el-dropdown-item>
            <el-dropdown-item v-if="roleList.length > 1" command="changeRole">切换角色</el-dropdown-item>
            <el-dropdown-item :divided="roleList.length > 1" command="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-header>
      <el-container style="height: calc(100% - 64px)">
        <el-aside
          :width="isCollapse ? '64px' : '150px'"
          style="background-color: #fff; transition: width 0.2s;height: 100%;"
        >
          <el-menu
            :default-active="selectedKeys"
            v-model="selectedKeys"
            class="layout-side"
            style=" height: 100%;overflow-y: auto;overflow-x: hidden;"
            :collapse="isCollapse"
            background-color="#434e5f"
            text-color="#fff"
            active-text-color="#409eff"
            @select="selectRoute"
          >
            <template v-for="t in userMenus">
              <el-submenu v-if="t.child_menus.length" :key="t.id" :index="t.id + ''">
                <template slot="title">
                  <img :src="t.icon" style="width: 16px; height: 16px; margin-right: 3px" alt />
                  <span slot="title">{{ t.name }}</span>
                </template>
                <el-menu-item
                  v-for="item in t.child_menus"
                  :index="item.router"
                  :key="item.id"
                >{{ item.name }}</el-menu-item>
              </el-submenu>
              <el-menu-item v-else :key="t.id" :index="t.router">
                <Icon
                  v-if="t.router === 'home'"
                  type="md-home"
                  style="font-size: 20px;vertical-align: sub"
                />
                <img v-else :src="t.icon" style="width: 16px; height: 16px; margin-right: 3px" alt />
                <span slot="title">{{ t.name }}</span>
              </el-menu-item>
            </template>
          </el-menu>
        </el-aside>
        <el-main>
          <Tabs
            class="page-tabs"
            v-model="selectedKeys"
            type="card"
            :closable="allSelectedKeys.length > 1"
            @on-tab-remove="handleTabRemove"
            @on-click="handleTabClick"
          >
            <TabPane
              v-for="r in allSelectedKeys"
              :key="r.key"
              :name="r.key"
              :label="renderLabel(r)"
            >
              <div
                v-if="!r.refesh"
                style="height: calc(100vh - 136px);overflow: auto;padding: 0 20px 0;"
              >
                <component :ref="r.key" :is="r.name" v-bind="r.extra"></component>
              </div>
              <div
                v-else
                style="height: calc(100vh - 136px);overflow: auto;margin: 0 20px 20px;background: #fff;"
                v-loading="r.refesh"
              ></div>
            </TabPane>
            <Dropdown slot="extra" :transfer="true" placement="bottom-end">
              <div style="line-height: 40px; padding-right: 20px">
                <Icon type="ios-list" :size="28" />
              </div>
              <DropdownMenu slot="list">
                <DropdownItem @click.native="refesh">
                  <Icon type="md-refresh" :size="14" />&nbsp;刷新当页
                </DropdownItem>
                <DropdownItem divided @click.native="refeshAll">
                  <Icon type="md-refresh" :size="14" />&nbsp;刷新所有
                </DropdownItem>
                <DropdownItem @click.native="closeAll">
                  <Icon type="md-close" :size="14" />&nbsp;关闭其他所有
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </Tabs>
        </el-main>
      </el-container>
    </el-container>
    <Modal v-model="roleShow" footer-hide :width="roleList.length * 265">
      <div slot="header" style="text-align: center">
        <span>切换角色</span>
      </div>
      <div class="role-container" v-loading.fullscreen.lock="fullscreenLoading">
        <div
          :class="['role-wrap', roleName === role.name ? 'active' : '']"
          v-for="(role, roleIndex) in roleList"
          :key="roleIndex"
          @click="handleRoleChange(role)"
        >
          <img class="role-avatar" v-if="role.name === '机构管理员'" src="../images/organization.png" />
          <img class="role-avatar" v-if="role.name === '科室管理员'" src="../images/dept.png" />
          <img class="role-avatar" v-if="role.name === '运营人员'" src="../images/yunying.png" />
          <img class="role-avatar" v-if="role.name === '团队成员'" src="../images/team.png" />
          <span class="role-name">{{role.name}}</span>
        </div>
      </div>
    </Modal>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import storage from 'store'
import { SHIFT_LIST } from '../utils/env'
import { querySearch } from '../api/patientList'
import route from '../route/config'
import caringTabDropdown from '../components/caring-tab-dropdown'
const colors = ['#87d068', '#64d9d6', '#f5c79b', '#f0565a']
const index = 2
export default {
  components: {
    home: () => import('../views/home/index.vue'),
    patientAdd: () => import('../views/patient/patientAdd'),
    schemeAdd: () => import('../views/resources/schemeAdd'),
    schemeList: () => import('../views/resources/scheme'),
    patientSummary: () => import('../views/config/patientSummary'),
    patientConfig: () => import('../views/config/patientConfig'),
    teamList: () => import('../views/manage/team'),
    deptList: () => import('../views/manage/dept'),
    drugList: () => import('../views/resources/drug'),
    userList: () => import('../views/manage/user'),
    teamDoctorList: () => import('../views/manage/teamDoctor'),
    roleList: () => import('../views/manage/role'),
    organizationList: () => import('../views/manage/organization'),
    diseaseList: () => import('../views/manage/disease'),
    addQues: () => import('../views/questionaire_new/createQuestionnaire'),
    patientLists: () => import('../views/slowDisease/patientLists'),
    filterBasic: () => import('../views/user/filter/filterBasic'),
    medicalBasic: () => import('../views/user/medical/medicalBasic'),
    typeFollowUp: () => import('../views/creatTask/typeFollowUp'),
    createNewObject: () => import('../views/creatTask/createNewObject'),
    objectList: () => import('../views/creatTask/objectList'),
    creatTask: () => import('../views/creatTask/creatTask.vue'),
    newsList: () => import('../views/article/newsListList'),
    newsAdd: () => import('../views/article/newsAdd'),
    module_news: () => import('../views/homeArticle/newsListList'),
    homeNewsAdd: () => import('../views/homeArticle/newsAdd'),
    createFollow: () => import('../views/creatTask/createFollow'),
    patientGroup: () => import('../views/slowDisease/patientGroup'),
    analysis: () => import('../views/slowDisease/analysis'),
    patientLabel: () => import('../views/slowDisease/patientLabel'),
    confirmedLabel: () => import('../views/slowDisease/confirmedLabel'),
    addGroup: () => import('../views/slowDisease/addGroup'),
    confirmedGroup: () => import('../views/slowDisease/confirmedGroup'),
    addGroup2: () => import('../views/slowDisease/addGroup2'),
    quesList: () => import('../views/slowDisease/quesList'),
    screenPatient: () => import('../views/addPatient/screenPatient'),
    confirmedLists: () => import('../views/slowDisease/confirmedLists'),
    confirmedAnalysis: () => import('../views/slowDisease/confirmedAnalysis'),
    depts: () => import('../views/article/depts'),
    information: () => import('../views/article/information'),
    typeManagement: () => import('../views/creatTask/typeManagement'),
    slowPatient: () => import('../views/addPatient/slowPatient'),
    editTask: () => import('../views/creatTask/editTask'),
    operate: () => import('../views/survey/operate'),
    surveyIndex: () => import('../views/survey/surveyIndex'),
    patientApply: () => import('../views/slowDisease/patientApply'),
    patientSelf: () => import('../views/config/patientSelf.vue'),
    questionIframe: () => import('../views/user/questionIframe.vue'),
    package: () => import('../views/manage/package.vue'),
    templateQuestionnaire: () =>
      import('../views/template/templateQuestionnaire'),
    diseaseBaseList: () => import('../views/manage/diseaseBaseList'),
    userCenter: () => import('../views/user/center.vue'),
    userSetting: () => import('../views/user/setting.vue'),
    miniQuestionnaire: () => import('../views/template/miniQuestionnaire'),
    deptCodeList: () => import('../views/manage/deptCodeList.vue'),
    addressList: () => import('../views/manage/addressList.vue'),
    // addressList1: () => import('../views/manage/addressList.vue'),
    packageOrder: () => import('../views/packageOrder/orderList.vue'),
    packageQues: () => import('../views/slowDisease/packageQues.vue'),
    packageDetail: () => import('../views/packageOrder/orderDetail.vue'),
    diagnosis: () => import('../views/manage/diagnosisList.vue'),
    diagnosisSort: () => import('../views/manage/diagnosisSort.vue'),
  },
  data() {
    return {
      isFilter: true,
      isCollapse: false,
      isFloat: false,
      isToggle: false,
      searchText: '',
      loading: true,
      userList: [],
      addType: '新增筛查人员',
      typeLists: ['新增筛查人员', '新增慢病患者'],
      avatarColor: colors[index],
      roleShow: false,
      modalLoading: false,
      fullscreenLoading: false,
    }
  },
  computed: {
    selectedKeys: {
      get() {
        return this.$store.state.activeKey
      },
      set(newVal) {
        this.$store.commit('setActiveKey', newVal)
      },
    },
    roleName() {
      if (this.shift.team_name) {
        return '团队成员'
      }
      if (this.shift.disease_name) {
        return '运营人员'
      }
      if (this.shift.dept_name) {
        return '科室管理员'
      }
      return '机构管理员'
    },
    ...mapGetters([
      'allSelectedKeys',
      'hasFilter',
      'hasSlow',
      'userMenus',
      'shift',
      'roleList',
      'shiftList',
      'curDeptList',
      'curDiseaseList',
      'curTeamList',
      'user',
    ]),
  },
  mounted() {
    console.log("usr",this.userMenus)
    if (!this.hasFilter && !this.hasSlow) {
      this.isFilter = false
      return
    }
    if (this.hasFilter && !this.hasSlow) {
      this.addType = '新增筛查人员'
      this.typeLists = ['新增筛查人员']
    } else if (!this.hasFilter && this.hasSlow) {
      this.addType = '新增慢病患者'
      this.typeLists = ['新增慢病患者']
    } else {
      this.addType = '新增筛查人员'
      this.typeLists = ['新增筛查人员', '新增慢病患者']
    }
    this.$nextTick(() => {
      this.calcWidth()
    })
    window.addEventListener('resize', this.calcWidth, true)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calcWidth, true)
  },
  methods: {
    handleRoleChange(role) {
      this.fullscreenLoading = true
      this.$store.commit('setShiftList', role.shift_institution_responses)
      storage.set(
        SHIFT_LIST +
          this.$store.state.user.user.id +
          this.$store.state.tenant.tenant,
        role.shift_institution_responses
      )
      this.commandInstitution(
        role.shift_institution_responses[0].institution_id
      )
    },
    handleCommand(command) {
      this[command]()
    },
    openIm() {
      this.$store.commit('setSessionModal', true)
    },
    getText(i) {
      const { lastMsg } = i
      if (lastMsg.type === 'custom') return '[自定义消息]'
      if (lastMsg.type === 'notification') return '[系统通知]'
      return ''
    },
    calcWidth() {
      const { clientWidth } = this.$refs.login || {}
      const documentWidth = document.documentElement.clientWidth
      const width = 635 + (this.isCollapse ? 64 : 150)
      if (documentWidth <= clientWidth + width) {
        this.isFloat = true
      } else {
        this.isFloat = false
      }
    },
    renderLabel(r) {
      return (h) =>
        h(caringTabDropdown, {
          props: {
            r,
          },
        })
    },
    commandInstitution(command) {
      const institution = this.shiftList.find(
        (item) => item.institution_id === command
      )
      const dept =
        institution.shift_dept_responses &&
        institution.shift_dept_responses.length
          ? institution.shift_dept_responses[0]
          : {}
      const disease =
        dept.shift_disease_responses && dept.shift_disease_responses.length
          ? dept.shift_disease_responses[0]
          : {}
      const team =
        disease.shift_team_responses && disease.shift_team_responses.length
          ? disease.shift_team_responses[0]
          : {}
      this.$store.dispatch('setShiftStore', {
        institution_id: institution.institution_id,
        institution_name: institution.institution_name,
        dept_id: dept.dept_id,
        dept_name: dept.dept_name,
        disease_id: disease.disease_id,
        disease_name: disease.disease_name,
        team_id: team.team_id,
        team_name: team.team_name,
      })
    },
    commandDept(command) {
      const dept = this.curDeptList.find((item) => item.dept_id === command)
      const disease =
        dept.shift_disease_responses && dept.shift_disease_responses.length
          ? dept.shift_disease_responses[0]
          : {}
      const team =
        disease.shift_team_responses && disease.shift_team_responses.length
          ? disease.shift_team_responses[0]
          : {}
      this.$store.dispatch('setShiftStore', {
        dept_id: dept.dept_id,
        dept_name: dept.dept_name,
        disease_id: disease.disease_id,
        disease_name: disease.disease_name,
        team_id: team.team_id,
        team_name: team.team_name,
      })
    },
    commandDisease(command) {
      const disease = this.curDiseaseList.find(
        (item) => item.disease_id === command
      )
      const team =
        disease.shift_team_responses && disease.shift_team_responses.length
          ? disease.shift_team_responses[0]
          : {}
      this.$store.dispatch('setShiftStore', {
        disease_id: disease.disease_id,
        disease_name: disease.disease_name,
        team_id: team.team_id,
        team_name: team.team_name,
      })
    },
    commandTeam(command) {
      const team = this.curTeamList.find((item) => item.team_id === command)
      this.$store.dispatch('setShiftStore', {
        team_id: team.team_id,
        team_name: team.team_name,
      })
    },
    selectRoute(index, indexPath) {
      if (
        !this.allSelectedKeys.find((a) => a.key === index) &&
        this.allSelectedKeys.length > 9
      ) {
        this.$Message.warning('您创建的页面过多,请先关闭!')
        return
      }
      // this.selectedKeys = index
      this.$store.commit('setAllSelectedKeys', {
        type: 'add',
        name: index,
        title: route[index].title,
        key: index,
        extra: {},
      })
    },
    handleTabClick(name) {
      this.current = name
    },
    handleTabRemove(targetKey) {
      let lastIndex = 0
      this.allSelectedKeys.forEach((pane, i) => {
        if (pane.key === targetKey) {
          lastIndex = i - 1
        }
      })
      this.$store.commit('setAllSelectedKeys', {
        type: 'delete',
        key: targetKey,
      })
      if (this.allSelectedKeys.length && this.selectedKeys === targetKey) {
        if (lastIndex >= 0) {
          this.$store.commit(
            'setActiveKey',
            this.allSelectedKeys[lastIndex].key
          )
        } else {
          this.$store.commit('setActiveKey', this.allSelectedKeys[0].key)
        }
      }
    },
    logout() {
      this.$confirm('确定要退出登录吗', '退出登录', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$store.dispatch('Logout').finally(() => {
            this.$router.replace({
              name: 'login',
            })
          })
        })
        .catch(() => {})
    },
    changeRole() {
      this.roleShow = true
    },
    closeAll() {
      const list = this.allSelectedKeys.filter(
        (l, i) => l.key === this.selectedKeys
      )
      this.$store.commit('setAllSelectedKeys', {
        type: 'allAdd',
        list,
      })
    },
    refesh() {
      const list = this.allSelectedKeys.map((l) => {
        if (l.key === this.selectedKeys) {
          l.refesh = true
        }
        return l
      })
      this.$store.commit('setAllSelectedKeys', {
        type: 'allAdd',
        list,
      })
      setTimeout(() => {
        const list = this.allSelectedKeys.map((l) => {
          if (l.key === this.selectedKeys) {
            l.refesh = false
          }
          return l
        })
        this.$store.commit('setAllSelectedKeys', {
          type: 'allAdd',
          list,
        })
      }, 400)
    },
    refeshAll() {
      const list = this.allSelectedKeys.map((l) => {
        l.refesh = true
        return l
      })
      this.$store.commit('setAllSelectedKeys', {
        type: 'allAdd',
        list,
      })
      setTimeout(() => {
        const list = this.allSelectedKeys.map((l) => {
          l.refesh = false
          return l
        })
        this.$store.commit('setAllSelectedKeys', {
          type: 'allAdd',
          list,
        })
      }, 400)
    },
    querySearch(queryString, cb) {
      const self = this
      if (queryString.length == 0) {
        self.$refs.elautocomplete.activated = false
        self.searchText = ''
        return
      }
      if (queryString.length > 0) {
        self.$refs.elautocomplete.activated =
          true || self.$refs.elautocomplete.handleFocus()
        self.getUser(queryString, cb)
      } else {
        self.$refs.elautocomplete.activated = false
      }
    },
    getUser(keywords, cb) {
      this.loading = false
      let type
      const pattern = new RegExp('[\u4E00-\u9FA5]+')

      if (this.hasFilter && !this.hasSlow) {
        type = 0
      } else if (this.hasSlow && !this.hasFilter) {
        type = 1
      } else if (this.hasFilter && this.hasSlow) {
        type = 2
      }
      querySearch({ keywords, type }).then((res) => {
        this.loading = true
        if (res.code === 0) {
          const userList = res.data
          if (pattern.test(keywords)) {
            userList.forEach((v, index) => {
              v.value = v.name
              v.index = index
            })
          } else {
            userList.forEach((v, index) => {
              if (v.id_card && v.id_card.includes(keywords)) {
                v.value = v.id_card
              } else if (v.phone && v.phone.includes(keywords)) {
                v.value = v.phone
              }
              v.index = index
            })
          }

          this.userList = userList
          this.fetch(keywords, cb)
        } else {
          this.$Message.error(res.message)
        }
      })
    },
    fetch(queryString, cb) {
      const { userList } = this
      const results = queryString
        ? userList.filter(this.createStateFilter(queryString))
        : userList
      if (results.length == 0) {
        // this.disabled = false
        // this.searchText = ''
        const obj = {}
        obj.names = '无匹配数据'
        results.push(obj)
      }

      this.results = results
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        cb(results)
      }, 0 * Math.random())
    },
    createStateFilter(queryString) {
      return (state) =>
        state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
    },
    handleClick(command) {
      this.addType = command
      this.goToType()
    },
    goToType() {
      if (this.addType == '新增筛查人员') {
        this.$store.commit('setAllSelectedKeys', {
          type: 'add',
          name: 'screenPatient',
          title: '新增筛查人员',
          key: 'screenPatient',
          extra: {},
        })
      } else {
        this.$store.commit('setAllSelectedKeys', {
          type: 'add',
          name: 'slowPatient',
          title: '新增慢病患者',
          key: 'slowPatient',
          extra: {},
        })
      }
    },
    goRouteUserSetting() {
      this.$store.commit('setAllSelectedKeys', {
        type: 'add',
        name: 'userSetting',
        title: '个人设置',
        key: 'userSetting',
      })
    },
    goRouteUserCenter() {
      this.$store.commit('setAllSelectedKeys', {
        type: 'add',
        name: 'userCenter',
        title: '个人中心',
        key: 'userCenter',
      })
    },
    patientDetail(i) {
      if (i.type == '筛查') {
        this.$store.commit('setAllSelectedKeys', {
          type: 'add',
          name: 'filterBasic',
          title: `${i.name}—筛查信息`,
          key: `filterBasic?${i.id}`,
          extra: {
            user: i,
          },
        })
      } else if (i.type == '慢病') {
        this.$store.commit('setAllSelectedKeys', {
          type: 'add',
          name: 'medicalBasic',
          title: `${i.name}—慢病信息`,
          key: `medicalBasic?${i.id}`,
          extra: {
            user: i,
          },
        })
      }
    },
  },
}
</script>
<style lang="less">
.basicLayout {
  .trigger-wrap {
    background: #263141;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    height: 60px;
    color: #f2f2f2;
    .trigger {
      font-size: 24px;
      cursor: pointer;
    }
    .rotate90 {
      transform: rotate(90deg);
    }
  }
  .page-title {
    display: flex;
    // justify-content: space-between;
    align-items: center;
    height: 60px;
    background: #414e62;
    color: #fff;
    font-size: 18px;
    padding: 0 40px 0 0px;
  }
  .loginout {
    display: flex;
    align-items: center;
    color: #efefef;
    font-size: 16px;
    white-space: nowrap;
    margin-left: 40px;
    &.flex {
      flex: 1;
      justify-content: flex-end;
    }
    &:hover {
      color: #fff;
    }
    .avatar-wrapper {
      width: 36px;
      height: 36px;
      line-height: 36px;
      text-align: center;
      font-size: 22px;
      border-radius: 6px;
    }
  }
  .el-dropdown-link {
    color: #fff;
    font-size: 14px;
    display: flex;
    align-items: center;
    > span {
      max-width: 180px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
  .head-item {
    margin-left: 25px;
    &:first-child {
      margin-left: 0;
    }
    cursor: pointer;
  }
  .layout-side {
    .el-submenu__title {
      background-color: #303d50;
    }
  }
  .page-tabs {
    .ivu-tabs-nav-next,
    .ivu-tabs-nav-prev {
      line-height: 40px;
    }
    &.ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-nav-container {
      height: 40px;
    }
    &.ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-tab {
      margin: 4px;
      border-bottom: 1px solid #dcdee2;
      border-radius: 4px;
      height: 32px !important;
    }
    &.ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-tab-active {
      padding-bottom: 0;
    }
  }
  .inline-input .el-input__inner {
    background-color: #2f394a;
    height: 35px;
    width: 190px;
    line-height: 35px;
    color: #fff;
  }
  .el-autocomplete-suggestion__wrap {
    // width: 180px;
  }

  .patient-item .el-button {
    background: #2f394a;
    color: #fff;
    padding: 9px 16px;
  }
  .patient-item .el-icon-plus {
    font-size: 14px;
  }
  .patient-item .el-button:focus,
  .patient-item .el-button:hover {
    color: #fff !important;
    border-color: #fff !important;
    background-color: #5a6274 !important;
  }

  .el-submenu .el-menu-item {
    min-width: 150px;
  }
  .el-menu-item i {
    color: #fff;
  }
  .el-menu-item.is-active i {
    color: inherit;
  }
}
.el-autocomplete-suggestion__list li {
  padding: 0 5px;
  margin: 0 10px;
  border-bottom: 1px solid #eee;
  .p {
    border-bottom: 1px solid #eee;
    line-height: 14px;
    padding-bottom: 10px;
    margin-bottom: 10px;
  }
  .name {
    margin: 5px 0;
    line-height: 20px;

    .patient-avatar {
      img {
        width: 20px;
        vertical-align: middle;
      }
    }
    .patient-name {
      color: #333;
      margin: 0 5px;
    }
    .patient-age {
      padding: 2px 4px;
      background: #faab69;
      color: #fff;
      border-radius: 5px;
      line-height: 12px;
      font-size: 12px;
      margin: 0 5px;
    }
    .patient-type {
      padding: 2px 4px;
      background: #f0f9ff;
      color: #3a7bef;
      border: 1px solid #3a7bef;
      border-radius: 5px;
      line-height: 12px;
      font-size: 12px;
    }
    .patient-typeMB {
      padding: 2px 4px;
      background: #fffaec;
      color: #f4bc25;
      border: 1px solid #f4bc25;
      border-radius: 5px;
      line-height: 14px;
      font-size: 14px;
    }
    .time {
      font-size: 14px;
      line-height: 25px;
    }
  }
}
.role-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  flex-wrap: no-wrap;
  margin: 40px 20px;
}
.role-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px;
  border: 1px solid #d8d8d8;
  margin: 0 12px;
  border-radius: 12px;
  cursor: pointer;
  box-sizing: border-box;
  &:hover {
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
  }
  &.active {
    border: 3px solid #4286f1;
    box-shadow: 0px 0px 3px 4px rgba(66, 134, 241, 0.3);
  }
}
.role-avatar {
  width: 140px;
  margin-bottom: 20px;
}
</style>
